import $ from "jquery"
import './../scss/style.scss';

//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { startIntroAnimation } from "./intro";
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { initWcag } from './shared/wcag'
import { initSearchForm } from './shared/search-form'

$(() => {
  WCAG.init();
  // do stuff on ready  
  initCommon();
  initCookies();
  initWcag();
  initSearchForm();
  // start intro / loading animation
  startIntroAnimation();
});

$(window).on( "load", ()=> {
  // do stuff on load
});